import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild,Input } from '@angular/core';
import { faMicrophoneAlt, faMicrophoneAltSlash, faVideo, faVideoSlash, faCog } from '@fortawesome/free-solid-svg-icons'
import { Subscription } from 'rxjs';
import { MediaService, MediaStreamType } from '../../services/media.service';
import { NavController,ModalController,Platform} from '@ionic/angular';
import { AgoraRTC, AgoraClient, Stream, NgxAgoraService, ClientEvent, StreamEvent } from 'ngx-agora';
import { ViewVideoApptWaitingRoomPtPage } from '../../../view-video-appt-waiting-room-pt/view-video-appt-waiting-room-pt.page';

@Component({
  selector: 'app-camera-preview',
  templateUrl: './camera-preview.component.html',
  styleUrls: ['./camera-preview.component.css']
})
export class CameraPreviewComponent implements AfterViewInit, OnDestroy {

  @Input() viewMoreData:any;
  @Output() childStatus = new EventEmitter<any>();

  @ViewChild('camera') cameraElementRef!: ElementRef;
  mobViewStatus:boolean=false;
  private subscriptions: Subscription[] = [];
  private stream?: MediaStream;
  public microphoneIcon = faMicrophoneAlt;
  public microphoneMutedIcon = faMicrophoneAltSlash;
  public cameraIcon = faVideo;
  public cameraOffIcon = faVideoSlash;
  public settingIcon = faCog;
  public isCameraOff = false;
  public isMicrophoneMute = false;
  public selectedVideoInId?: string;
  showSettings = false;
  public localStream: Stream;
  cameraPreview=true;
  localCallId = 'agora_local';

  constructor(private mediaService: MediaService,
    private navCtrl:NavController,
    private agoraService: NgxAgoraService,
    private modalCtrl: ModalController,
    private platform: Platform) {
      //this.localCameraPreview();
      let deviceWidth = this.platform.width();
      //alert(deviceWidth);
      if(deviceWidth<750) {
        this.mobViewStatus=true;
        console.log(this.mobViewStatus);
      } else {
        this.mobViewStatus=false;
      }
    this.platform.resize.subscribe(async () => {
      let deviceWidth = this.platform.width();
      //alert(deviceWidth);
      if(deviceWidth<750) {
        this.mobViewStatus=true;
        console.log(this.mobViewStatus);
      } else {
        this.mobViewStatus=false;
      }
    });

  }

  async viewMore() {
    const modal = await this.modalCtrl.create({
      component: ViewVideoApptWaitingRoomPtPage,
      componentProps: {
        ptWaitingRoomList: this.viewMoreData.ptList,
        docDetails:this.viewMoreData.docDetails
      },
      backdropDismiss: true,
      animated: true,
    });
    modal.onDidDismiss().then(data => {
      console.log(data);
      if(data.data=="close")
      {
        //this.getWaitingPtList();
      }
      if(data.data.appt!=null)
      {
        this.childStatus.emit(data);
        //alert("Hi");
        //this.prepareVideoCall(data.data);
      }
    });
    modal.present();
  }

  localCameraPreview()
  {
    //this.assignClientHandlers();
    // Added in this step to initialize the local A/V stream
    this.cameraPreview=true;
    this.localStream = this.agoraService.createStream({
      streamID: '12345',
      audio: true,
      video: true,
      screen: false,
    });
    this.assignLocalStreamHandlers();
    // Join and publish methods added in this step
    this.initLocalStream();
  }

  private assignLocalStreamHandlers(): void {
    this.localStream.on(StreamEvent.MediaAccessAllowed, () => {
      console.log('accessAllowed');      
    });
  }

  private initLocalStream(onSuccess?: () => any): void {
    this.localStream.init(
      () => {
        // The user has granted access to the camera and mic.
        this.localStream.play(this.localCallId);
        if (onSuccess) {
          onSuccess();
        }
      },
      (err) => console.error('getUserMedia failed', err)
    );
  }

  join(
    onSuccess?: (uid: number | string) => void,
    onFailure?: (error: Error) => void
  ): void {
    //this.client.join(this.rtcToken, this.channelName, this.uid, onSuccess, onFailure);
  }

  ngAfterViewInit(): void {
    const vsubscription = this.mediaService.selectedVideoInputId.subscribe(id => {
      this.selectedVideoInId = id;
      this.startCameraMic(this.selectedVideoInId);
    });
    this.subscriptions.push(vsubscription);
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
    if (this.stream) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }

  async startCameraMic(camDeviceId?: string) {
    if (this.isCameraOff) {
      if (this.stream) {
        this.stream.getTracks().forEach(track => {
          track.stop();
        });
      }
      return;
    }
    const mediaStreamType = MediaStreamType.video;
    this.stream = await this.mediaService.getMediaStream(mediaStreamType, undefined, undefined, camDeviceId);

    this.cameraElementRef.nativeElement.srcObject = this.stream;    
    this.cameraElementRef.nativeElement.onloadedmetadata = () => {
    this.cameraElementRef.nativeElement.play();
      
    };
  }

  onMicrophoneClicked(state: boolean) {
    this.isMicrophoneMute = state;
  }

  onCameraClicked(state: boolean) {
    this.isCameraOff = state;
    this.startCameraMic(this.selectedVideoInId);
  }

  onShowSettings() {
    this.showSettings = true;
  }

  onCloseSettings() {
    this.showSettings = false;
  }

  previewLeave()
  {    
    this.navCtrl.back();
  }

}
